import { useCan, useSelectedLocation } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Checklist } from "models";

const sortChecklistsByDisplayOrder = (checklists: Checklist[]) => checklists.toSorted((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));

export const useLocationChecklistsQuery = () => {
  const { selectedLocation } = useSelectedLocation();
  const canListLocations = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.Locations);

  return useTypedQuery({
    queryKey: ChecklistsDashboardQueryKeys.locationChecklists(selectedLocation?.id),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.checklists ?? [],
    select: sortChecklistsByDisplayOrder,
    enabled: !!selectedLocation?.id && canListLocations
  });
};
